import { useEffect, useSyncExternalStore } from "react";
import { ordersFor, type OrderScope } from "@/api/resources";
export function useOrders(scope: OrderScope, enabled = true) {
  const resource = ordersFor(scope);
  useSyncExternalStore(resource.observe, resource.version);
  useEffect(() => (enabled ? resource.acquire() : undefined), [resource, enabled]);
  return {
    rows: resource.get(),
    status: resource.status(),
    error: resource.error(),
    refresh: resource.refresh,
  };
}
